import React from 'react';
import { GraphComponent } from '../../chat/formatters/GraphFormatter';
import MobileChatGraphView from './MobileChatGraphView';

const CHART_THEME = {
  colors: {
    primary: "#E08A08", // Main primary
    secondary: "#3b82f6", // Blue for contrast
    accent: "#10b981", // Green
    warning: "#8b5cf6",
    info: "#f43f5e",
    success: "#06B6D4",
    text: "#171717",
    textSecondary: "#737373",
    cardBackground: "#ffffff",
    cardBorder: "#e5e7eb",
    surfaceElevated: "#f9fafb",
    border: "#e5e7eb",
  },
};

const BAR_CHART_DATA = {
  type: "bar",
  title: "Science Performance: 8-C (Mid-Term vs Last Term)",
  labels: ["Physics", "Chemistry", "Biology", "Env. Sci"],
  datasets: [
    { label: "Last Term Avg", data: [75, 84, 72, 78] },
    { label: "Mid-Term Avg", data: [88, 68, 79, 85] },
  ],
  options: {
    xAxisTitle: "Subjects",
    yAxisTitle: "Score (%)",
  },
};

export default function AIChatResponseWidget() {
  return (
    <div className="flex justify-start gap-3 w-full pr-4">
      <div className="w-8 h-8 rounded-full bg-primaryColor flex-shrink-0 flex items-center justify-center text-white text-xs font-bold">AI</div>
      <div className="bg-neutral-50 shadow-sm border border-neutral-100 px-5 py-5 rounded-2xl rounded-tl-none text-sm font-medium w-full overflow-hidden">
        <p className="text-neutral-800 mb-4 leading-relaxed">
          Based on the Mid-term results, Class 8-C has shown an overall <strong className="text-primaryColor font-bold">12% improvement</strong> in Science compared to last term.
        </p>
        
        <div className="mb-6">
          <p className="text-xs font-bold text-neutral-400 uppercase tracking-widest mb-3">Key Highlights</p>
          <ul className="space-y-3">
            <li className="flex items-start gap-2">
              <span className="text-green-500 mt-0.5 material-symbols-outlined text-sm">trending_up</span>
              <span className="text-neutral-600"><strong>Physics:</strong> Remains the strongest subject, with the average score increasing to 88%.</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-blue-500 mt-0.5 material-symbols-outlined text-sm">trending_flat</span>
              <span className="text-neutral-600"><strong>Biology & Env. Sci:</strong> Have shown steady growth and consistent performance.</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-amber-500 mt-0.5 material-symbols-outlined text-sm">warning</span>
              <span className="text-neutral-600"><strong>Chemistry Attention Needed:</strong> The average dropped to 68%. 15% of students require additional remedial help.</span>
            </li>
          </ul>
        </div>

        {/* Interactive Chart Widget */}
        <div className="mt-2 w-full">
          {/* Desktop/Web view */}
          <div className="hidden md:block w-full overflow-hidden bg-white rounded-xl border border-neutral-100">
            <GraphComponent graphData={BAR_CHART_DATA} theme={CHART_THEME} enableAnimation={true} />
          </div>
          {/* Mobile view */}
          <div className="block md:hidden w-full">
            <MobileChatGraphView graphData={BAR_CHART_DATA} theme={CHART_THEME} />
          </div>
        </div>
      </div>
    </div>
  );
}
